export { PublicCommunityPost as default } from '@/features/inquiry-library';
